import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Menu, LogOut } from "lucide-react";

const Dashboard = ({ setIsLoggedIn }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  // ✅ Logout function
  const handleLogout = () => {
    localStorage.removeItem("adminToken"); // clear token
    setIsLoggedIn(false);                  // update state
    navigate("/");                         // go to login
  };

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>

      {/* Sidebar */}
      <Sidebar collapsed={isCollapsed} onLogout={handleLogout} />

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >

        {/* AppBar */}
        <div
          className="d-flex align-items-center justify-content-between px-3 shadow-sm bg-light"
          style={{
            height: "60px",
            flexShrink: 0,
          }}
        >
          <Button
            variant="outline-secondary"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <Menu size={20} />
          </Button>

          <h5 className="m-0">Admin Dashboard</h5>

          {/* Logout button */}
          <Button variant="danger" size="sm" onClick={handleLogout}>
            <LogOut size={16} className="me-1" />
            Logout
          </Button>
        </div>

        {/* Page Content */}
        <div className="p-4" style={{ flex: 1, overflow: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;